import { addBreadcrumb, captureException } from '@sentry/react'
import { getDownloadURL, getStorage, ref, uploadBytes, UploadMetadata } from 'firebase/storage'
import { nanoid } from 'nanoid'

export const getFirebaseStorageUrl = async (storagePath: string | null | undefined): Promise<string | null> => {
  if (!storagePath) {
    return null
  }

  try {
    const storage = getStorage()
    const storageRef = ref(storage, storagePath)
    const url = await getDownloadURL(storageRef)
    return url
  } catch (error) {
    captureException(error, {
      tags: {
        storagePath,
      },
    })
    return null
  }
}

export const uploadFileToStorage = async (file: File, path: string, metadata?: UploadMetadata): Promise<string> => {
  const fileExtension = file.name.split('.').pop()
  const storageRef = ref(getStorage(), `${path}/${nanoid()}.${fileExtension}`)
  addBreadcrumb({
    category: 'storage',
    message: `Uploading file to ${storageRef.fullPath}`,
    data: {
      file: file.name,
      path,
      metadata,
    },
  })
  const snapshot = await uploadBytes(storageRef, file, metadata)
  const publicUrl = getDownloadURL(snapshot.ref)
  addBreadcrumb({
    category: 'storage',
    message: `File uploaded to ${storageRef.fullPath}`,
    data: {
      publicUrl,
    },
  })
  return publicUrl
}
